// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3Tj-7","header":"Messages_header__1IEXO"};